import { render } from "./RuleTemplatesPage.vue?vue&type=template&id=4090bb2a"
import script from "./RuleTemplatesPage.vue?vue&type=script&lang=js"
export * from "./RuleTemplatesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__